import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { WizardStepLayout } from '../../wizard/wizard-summary-layout';
import AccessGroupColumns from "../../../models/ColumnDefinitions/AccessGroupColumns";
import AccessGroupSearch from "../../../models/search/AccessGroupSearch";
import { removeColumns } from "../../../models/utilities/columnHelper";
import { getAllAccessGroups } from "../../../services/accessGroupService";
import TableTab from "../../tabs/table-tab";

interface AccessGroupStepProps {
    onNext: (e: any) => void;
    onBack: (e: any) => void;
    setTotalAccessGroups: React.Dispatch<React.SetStateAction<number>>;
}

const AccessGroupStep: FC<AccessGroupStepProps> = ({ onNext, onBack, setTotalAccessGroups }) => {
    const { setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    const onLocalNext = (e: any) => {
        setTotalAccessGroups(selectedIds.length);
        setFieldValue("accessGroups", selectedIds);
        setFieldValue("accessGroupRows", selectedRows);
        onNext(e);
    }

    return <WizardStepLayout onBack={onBack} onNext={onLocalNext}>
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <TableContextProvider
                dataMethod={(listParameters) => getAllAccessGroups(1, translate, listParameters)}
                tableDescriptor={removeColumns(AccessGroupColumns, ['days', 'startTime', 'duration', 'enrolments', 'accessProfile'])}
                searchDescriptor={AccessGroupSearch}
                useTable
                usePagination
                useFilter
                useSearch
                useSort>
                <TableTab
                    title={translate.byKey(TranslationKeys.accessGroups)}
                    selectRows={true}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    cyName="accessGroupStep"
                />
            </TableContextProvider>
        </div>
    </WizardStepLayout>
}

export default AccessGroupStep;